module.exports = __webpack_public_path__ + "img/bsu.4afcb447.jpg";